module.exports = __webpack_public_path__ + "static/media/1016433.16132279.png";